<template>
  <div class="timeline-event-appointment">
    <div class="timeline-event-appointment__subtitle mb-3">
      <span v-if="is_first">
        <strong>PRIMERA CITA: {{ assigned_unit }}</strong>
      </span>
      <span v-else>
        TRATAMIENTOS <button class="btn btn-wabident-round small timeline-event-quotation__edit"
          @click="editAppointment">
          {{ edit_button_title }}
        </button>
      </span>
    </div>

    <div v-if="!is_first">
      <event-treatment-detail v-for="treatment in entity.treatments" :doctor_names="doctor_names" @done="done"
        @note="note" @assign="assign" :key="treatment.id" :treatment="treatment" @appointment="appointment"
        :event="event"></event-treatment-detail>
    </div>

    <div v-if="entity.notes && entity.notes !== ''">
      <div class="timeline-event-appointment__subtitle">
        OBSERVACIONES
      </div>
      <div class="timeline-event-historyentry__text" v-html="entity_notes">
      </div>
    </div>

    <div v-if="has_next_app">
      <div class="timeline-event-appointment__subtitle">
        PRÓXIMA CITA <small>(Aprox.)</small>
      </div>
      <div class="timeline-event-historyentry__text">
        <div v-if="entity.next_app_data.date_from"><strong>Fecha: </strong> {{ next_date }}</div>
        <div v-if="entity.next_app_data.doctor_id"><strong>Doctor: </strong> {{ next_doctor }}</div>
        <div v-if="entity.next_app_data.notes"><strong>Notas: </strong> {{ next_notes }}</div>
      </div>
    </div>

    <timeline-event-documents style="margin-top: 15px" :documents="entity.documents">
    </timeline-event-documents>
  </div>
</template>

<script>

export default {
  props: ['event', 'entity', 'doctor_names'],
  computed: {
    entity_notes() {
      if (this.entity.notes && this.entity.notes !== '') {
        let regex = /\n+/gi
        return this.entity.notes.replaceAll(regex, '<br>');
      }

      return '';
    },
    has_next_app() {
      return this.entity.next_app_data && (
        this.entity.next_app_data.doctor_id ||
        this.entity.next_app_data.notes ||
        this.entity.next_app_data.date_from);
    },
    next_date() {
      return moment(this.entity.next_app_data.date_from).format('DD/MM/YY');
    },
    next_doctor() {
      return this.doctor_names[this.entity.next_app_data.doctor_id] || 'N/D';
    },
    next_notes() {
      return this.entity.next_app_data.notes;
    },
    assigned_unit() {
      let cat = this.clinic.product_categories.filter((cat) => {
        return cat.id == this.entity.product_category_id;
      })[0];

      return cat ? cat.name : 'Sin Unidad';
    },
    is_first() {
      return this.entity.is_first;
    },
    edit_button_title() {
      return (this.entity.treatments && this.entity.treatments.length) ? 'Editar' : 'Asignar';
    },
    ...mapGetters(['msgwindow', 'errorwindow', 'clinic'])
  },
  methods: {
    editAppointment() {
      this.$emit('edit', this.event, this.entity);
    },
    done(treatment) {
      this.$emit('done', this.event, treatment);
    },
    appointment(treatment) {
      this.$emit('appointment', this.event, treatment);
    },
    note(treatment) {
      this.$emit('note', this.event, treatment);
    },
    assign(treatment) {
      this.$emit('assign', this.event, treatment);
    },
  },
}
</script>

<style lang="scss">
.timeline-event-appointment {
  &__subtitle {
    margin-top: 15px;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 5px;
  }

  &__edit {
    font-weight: bold;
  }
}
</style>
